// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__lurBR","author":"Table_author__2-7D0","authorImage":"Table_authorImage__Z3eRj","unreadRow":"Table_unreadRow__11Tsq"};